import { useState, useRef } from "react";
import { FiMenu } from "react-icons/fi";
import Logo from "../../elements/logo/Logo";
import Nav from "./Nav";
import MobileMenu from "./MobileMenu";
import Darkmode from "./Darkmode";
import useStickyHeader from "./useStickyHeader";

const HeaderOne = ({ btnStyle, HeaderSTyle }) => {
  const [ofcanvasShow, setOffcanvasShow] = useState(false);
  const onCanvasHandler = () => {
    setOffcanvasShow((prev) => !prev);
  };
  const ref = useRef();
  let [check, setCheck] = useState(true);
  const sticky = useStickyHeader(50);
  const headerClasses = `header-default ${sticky && check ? "sticky" : ""}`;
  const { clientHeight } = ref;

  const checkChange = (value) => {
    setCheck(value);
  };
  return (
    <>
      <header
        ref={ref}
        role="banner"
        className={`rn-header header-default ${HeaderSTyle} ${headerClasses}`}
      >
        <div className="container position-relative">
          <div className="row align-items-center row--0">
            <div className="col-lg-3 col-md-6 col-4">
              <Logo
                image={`${process.env.PUBLIC_URL}/images/logo/WhatsOnAgencyWhite.png`}
                image2={`${process.env.PUBLIC_URL}/images/logo/WhatsOn_AgencyRed.png`}
              />
            </div>
            <div className="col-lg-9 col-md-6 col-8 position-static">
                <div className="header-right">
                    <nav className="mainmenu-nav d-none d-lg-block" aria-label="Main navigation" role="navigation">
                        <Nav />
                    </nav>
                    <div className="header-btn d-none d-lg-block">
                        <a
                            className={`btn-default btn-small round btn-icon ${btnStyle}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            href="/special-offer"
                        >
                            GET A QUOTE
                        </a>
                    </div>

                    <div className="header-btn d-none d-lg-block">
                        <a
                            className={`btn-default btn-small round btn-icon${btnStyle}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            href="/free-digital-audit"
                        >
                            DIGITAL AUDIT
                        </a>
                    </div>

                    <div className="mobile-menu-bar ml--5 d-block d-lg-none">
                        <div className="hamberger">
                            <button
                                type="button"
                                className="hamberger-button"
                                onClick={onCanvasHandler}
                                aria-label="Toggle mobile menu"
                                aria-expanded={ofcanvasShow}
                            >
                                <FiMenu />
                            </button>
                        </div>
                    </div>
                    <div className="d-none d-lg-block">
                        <Darkmode />
                    </div>
                </div>
            </div>
          </div>
        </div>
      </header>
      <MobileMenu show={ofcanvasShow} onClose={onCanvasHandler} />
    </>
  );
};
export default HeaderOne;
